module.exports = "/images/risk-slideshow-2.png?acd1c67de7ffbc5f469463e4c335d492";